﻿import { useEffect } from 'react';

import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { useTransactionDetails } from 'pages/access_codes/context';
import { TransactionApi } from 'apis/TransactionApi';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/access_codes/components/XedReportsTab/styles/xed-reports-tab.scss';

export const XedReportsTab = () => {

    const [state, setState] = useSuperState({
        errorMessage: '',
        loading: false,
        transactionHasXEDEnabled: false,
        xedGroupManagementUrl: ''
    });
    const { errorMessage, loading, transactionHasXEDEnabled, xedGroupManagementUrl } = state;

    const { userId } = useApp();
    const { pageContext } = useTransactionDetails();

    const getXEDEditGroupUrl = async () => {

        if (pageContext && pageContext.Data && pageContext.Data.transactionDetails && pageContext.Data.transactionDetails.HasXED === true && pageContext.Data.transactionDetails.XEDExternalId.length > 0) {

            setState({ loading: true });
            try {

                const resp = await TransactionApi.GetXEDEditGroupUrlByTransactionAndUserId(pageContext.Data.transactionDetails.Id, userId);
                if (resp.Done === true && resp.Message.length > 0) {

                    // HACK: string replacement to get the report URL from the group management URL
                    const reportUrl = resp.Message.replace('/group-management/edit-group/', '/reports/general-information/');
                    setState({ loading: false, transactionHasXEDEnabled: true, xedGroupManagementUrl: reportUrl });

                } else {

                    setState({ errorMessage: resp.Message, loading: false });

                }

            } catch (err: any) {

                setState({ errorMessage: err.Message, loading: false });

            }

        }

    };

    useEffect(() => {

        if (pageContext && pageContext.Data && pageContext.Data.transactionDetails && pageContext.Data.transactionDetails.XEDExternalId)
            setState({ transactionHasXEDEnabled: pageContext.Data.transactionDetails.XEDExternalId.length > 0 });

    }, [pageContext?.Data.transactionDetails]);

    useEffect(() => {

        if (transactionHasXEDEnabled === true && xedGroupManagementUrl.length === 0) {

            getXEDEditGroupUrl();

        }

    }, [transactionHasXEDEnabled]);

    return (
        <>
            {pageContext && (
                <>

                    {loading && errorMessage.length === 0 && (
                    <div className="text-center">
                        <GMetrixLoader/>
                    </div>
                    )}

                    {!loading && errorMessage.length === 0 && transactionHasXEDEnabled && (
                    <div className="text-center">
                        <iframe height="100%" id={'xed-reports-frame-' + pageContext.Data.transactionDetails?.Id} src={xedGroupManagementUrl} style={{ minHeight: '600px' }} width="100%"></iframe>
                    </div>
                    )}

                </>
            )}
        </>
    );

};
